import buildCorrectGrammarText from "Common/componentUtils/buildCorrectGrammarText";
export default {
    CREATE_WORK_SPACE: "Создать пространство",
    EDIT_WORK_SPACE: "Редактировать пространство",
    DELETE_WORK_SPACE: "Удалить пространство",
    CONFIRM_DELETE_WORK_SPACE_TEXT: "Вы уверены, что хотите удалить это пространство?",
    CONFIRM_DELETE_WORK_SPACE_HEADER: "Удалить пространство",
    CREATE_PROJECT: "Создать проект",
    CREATE_PROJECT_DESCRIPTION: "Создайте новый проект в текущем пространстве",
    IMPORT_PROJECT: "Импортировать проект",
    IMPORT_PROJECT_DESCRIPTION: "Вы можете загрузить файл в формате ......",
    PROJECTS: "Проекты",
    TASKS: "Задачи",
    MANAGE_ACCESS: "Управление доступом",
    TASK_STATISTICS: "Статистика задач",
    buildCountProjectsTitle: (count) => `${count} ${buildCorrectGrammarText(count, ["проект", "проекта", "проектов"])}`,
    NO_DATA_TEXT: "Здесь пока нет проектов",
    buildCountTasksTitle: (count) => `${count} ${buildCorrectGrammarText(count, ["задача", "задачи", "задач"])}`,
    TASK_NAME: "Название задания",
    SEARCH_CRITERIA: "Критерии поиска",
    METHOD: "Метод",
    CREATED: "Создана",
    DURATION: "Длительность",
    AUTHOR: "Автор",
    DOCUMENT: "Документ",
    WATCH_TASK_LOGS: "Посмотреть лог задания"
};
